import Tag from 'src/components/DataDisplay/Tag/Tag'
import { formatSnakeValue } from 'src/lib/formatters'

import { getOrderStatusVariant } from '../helpers'

type Props = {
  status?: string
}

const StatusCell = ({ status }: Props) => {
  if (!status) return null
  return (
    // Tag is a nowrap flex item, so a long label's min-content width spills
    // out of a fixed table cell. Constrain it to the cell and wrap instead.
    <div className="flex min-w-0 max-w-full">
      <Tag
        variant={getOrderStatusVariant(status)}
        size="xs"
        showCloseButton={false}
        wrap
        className="min-w-0 max-w-full"
      >
        <span className="min-w-0 break-words">{formatSnakeValue(status)}</span>
      </Tag>
    </div>
  )
}

export default StatusCell
